import React, { useRef, useEffect } from "react";
import WidgetHeader from "./Header";
import { useDispatch, useSelector } from "react-redux";
import ErrorBoundary from "../../../../ErrorBoundary";
import AggregateChart from "../../../workspace/AggregateChart/AggregateChart";
import NoGraphData from "../../../workspace/DisplayChart/NoGraphData";
import HighCharts from "../../../utils/charts/HighCharts/index";
import BubbleChart from "../../../utils/charts/d3Graphs/BubbleChart";
import MapGraph from "../../../utils/charts/d3Graphs/MapGraph";
import TableCharts from "../../../workspace/DisplayChart/TableCharts";
import TwoSplitWidget from "./TwoSplit";
import ThreeSplitWidget from "./ThreeSplitWidget";
import uuid from "react-uuid";
import OrmGraphs from "../../ORMWidget/ormGraphs";
import TicketTat from "../../commonWidgets/TicketTat";
import WidgetMakerChart from "../../../WidgetMaker/Chart";
import Refreshblue from "../../../../assets/Refresh-blue.svg";
import { Button, Input, Skeleton } from "antd";
import { setAIGeneratedInsights } from "../../../../redux/actions/PPT";
import { setWidgetAIGeneratedInsightsOpenStatus } from "../../../../redux/actions/dashboard/Tab1";
import { getPaneIndex } from "../../../../redux/constants";
import { useState } from "react";
import config1 from "../../../../config";
import { useInView } from "react-intersection-observer";
import { scroller } from "react-scroll";
import {
  setGlobalSelectedWidgetId,
  setVisitedWidgetId,
} from "../../../../redux/actions/dashboard/dashboard";
import isEqual from "react-fast-compare";
import SomethingWrong from "../../../workspace/DisplayChart/SomethingWrong";
import depricatedWidgetImage from "../../../../assets/depricated_widget_image.svg";
import { WarningOutlined } from "@ant-design/icons";
import twitterDepricatedWidgetImage from "../../../../assets/twitter_depricated_image.svg";
import { SocialMedialogoDeprecated } from "../../../layout/DeepDive/DeepDivetab/SocialMediaPlatforms";

const NewlineText = (props) => {
  const text = props.text;
  return text?.length > 0
    ? text
        ?.split("\n")
        ?.map((str) => <p className="text_regular-gray font-size14">{str}</p>)
    : "";
};
const WidgetGraph = ({
  propsId,
  data,
  section_id,
  widget_index,
  section_index,
  template_widget,
  dashboard,
  sections,
  span_data,
}) => {
  const dispatch = useDispatch();
  const refChartOut = useRef();

  let graphData = data?.template_id
    ? data
    : template_widget
    ? Array.isArray(data?.data)
      ? data
      : data?.data
    : data?.graphData?.data || data?.persist_graphdata?.data
    ? data?.graphData
      ? data?.graphData
      : data?.persist_graphdata
    : Array.isArray(data?.graphData || data?.persist_graphdata)
    ? data?.graphData[0]
      ? data?.graphData[0]
      : data?.persist_graphdata[0]
    : data?.graphData
    ? data?.graphData
    : data?.persist_graphdata;
  const panes = useSelector((state) => state.Tab1.panes);
  const activeKey = useSelector((state) => state.Tab1.activeKey);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const errorCode = useSelector((state) => state.Workspace.errorCode);
  const aiInsightsLoader = useSelector((state) => state.PPT.aiInsightsLoader);
  const Section = useSelector((state) => state.Section.addSection);
  let index = getPaneIndex(panes, activeKey);
  const section = panes[index]?.section;
  const footerValue = useSelector((state) => state.Section.footerValue);
  const globalSelectedWidgetId = useSelector(
    (state) => state?.dashboard?.global_selected_widget_id
  );
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const share_selected_deepdive_widget = useSelector(
    (state) => state?.Share?.share_selected_deepdive_widget
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );

  const chart__styles = {
    width: "100%",
    height: "450px",
    margin: "auto",
  };

  const { ref, inView, entry } = useInView({
    trackVisibility: true,
    delay: 100,
    root: document,
    rootMargin: `0px 20px 0px 40px`,
    threshold: 0.0,
  });

  const [promptText, setpromptText] = useState(null);
  let widgetObj = {
    id: propsId,
    widget_name: graphData?.widget_name,
    section_id: section_id,
    widget_id: data?.widget_id ? data?.widget_id : data?.id,
    widget_index: widget_index,
    section_index: section_index,
    graph_type: graphData?.graph_type,
    widgets: graphData,
    template_widget: template_widget,
    dashboard: dashboard,
  };
  const handlePrompt = (e) => {
    setpromptText(e.target.value);
  };
  const handleEnter = () => {
    callInsights(promptText);
  };

  const callInsights = (text) => {
    let sections = panes[index]?.sections
      ? panes[index]?.sections
      : panes[index]?.section;
    let payload =
      sections?.[section_index > 0 ? section_index : 0]?.widgets[widget_index]
        ?.payload;
    let widget = {
      pane_index: index,
      panes: panes,
      section_index: panes[index]?.sections ? section_index : null,
      widget_index: widget_index,
      widget_id:
        sections?.[section_index > 0 ? section_index : 0]?.widgets[widget_index]
          ?.widget_id,
      dashboard_name: panes?.[index]?.template_name,
      prompt_text: promptText,
    };
    dispatch(
      setWidgetAIGeneratedInsightsOpenStatus(
        true,
        index,
        panes,
        widget?.section_index,
        widget?.widget_index
      )
    );

    if (payload && text) {
      payload && dispatch(setAIGeneratedInsights(payload, widget, authParams));
    } else {
      payload && dispatch(setAIGeneratedInsights(payload, widget, authParams));
    }
  };

  useEffect(() => {
    if (inView && entry?.target?.id) {
      let custom_id = entry?.target?.id.split("#")[0];
      if (custom_id === data?.widget_id) {
        // console.log("entry id =>",entry?.target?.id);
        dispatch(setVisitedWidgetId(entry?.target?.id));
      }
    }
  }, [inView]);

  useEffect(() => {
    let pagePosition = document.documentElement.scrollTop;
    if (globalSelectedWidgetId && pagePosition > 60) {
      scroller.scrollTo(globalSelectedWidgetId, {
        duration: 0,
        delay: 0,
        // smooth: true,
        offset: shareTemplateData
          ? section_index >= 0
            ? -190
            : -160
          : section_index >= 0
          ? -140
          : -100,
      });
      // clear
      dispatch(setGlobalSelectedWidgetId(null));
    }
  }, [globalSelectedWidgetId]);

  const AiInsightsBrands =
    data?.payload?.brand_list?.length === 1 &&
    !data?.payload?.brand_groups &&
    !data?.payload?.comp_brand_list;

  let reason, plateformId;
  if (typeof graphData === "string" && graphData?.includes("$DP$")) {
    [reason, plateformId] = graphData?.split("$DP$");
  }

  if (data?.splits?.columns?.length === 2)
    return (
      <TwoSplitWidget
        data={graphData}
        chart__styles={chart__styles}
        splitFinalObj={data?.splits}
        widgetObj={widgetObj}
        widget_index={widget_index}
        section_index={section_index}
        template_widget={template_widget}
        sections={sections}
        section={section}
      />
    );
  else if (data?.splits?.columns?.length === 3) {
    return (
      <ThreeSplitWidget
        data={graphData}
        chartStyles_New={chart__styles}
        splitFinalObj={data?.splits}
        widgetObj={widgetObj}
        widget_index={widget_index}
        section_index={section_index}
        template_widget={template_widget}
        sections={sections}
        section={section}
      />
    );
  } else
    return (
      <>
        {typeof graphData === "object" &&
        graphData?.data &&
        typeof graphData?.data !== "string" ? (
          <>
            <div
              ref={ref}
              id={data?.widget_id + "#" + section_id + "#" + widget_index}
              className="Dashboard__Widget--header"
            >
              <WidgetHeader
                id={propsId}
                widget_name={
                  data?.widget_name ? data?.widget_name : graphData?.widget_name
                }
                widget_description={
                  data?.widget_description
                    ? data?.widget_description
                    : graphData?.widget_description
                    ? graphData?.widget_description
                    : template_widget
                    ? Section?.[section_index]?.data[widget_index]
                        ?.widget_description
                    : sections
                    ? sections?.[section_index]?.widgets[widget_index]
                        ?.widget_description
                    : section &&
                      section[0]?.widgets[widget_index]?.widget_description
                }
                section_id={section_id}
                widget_id={data?.widget_id ? data?.widget_id : data?.id}
                widget_index={widget_index}
                section_index={section_index}
                graph_type={graphData?.graph_type}
                widgets={graphData}
                template_widget={template_widget}
                dashboard={dashboard}
                sections={sections}
                allData={graphData}
                chart_type={
                  graphData?.graph_type
                    ? graphData?.graph_type
                    : data?.graph_type
                    ? data?.graph_type
                    : data?.chart?.chart_type
                }
                widgetData={data}
                pane_section={panes?.[index]?.section}
                selectedDeepdiveWidget={
                  shareTemplateData
                    ? share_selected_deepdive_widget
                    : panes?.[index]?.selected_deepdive_widget
                }
                templateAccessType={panes?.[index]?.access_type}
              />
            </div>
            {AiInsightsBrands &&
            panes[index]?.template_id === "000-000-2001" &&
            panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
              ?.widget_name !== "Mentions Trend With Engagement" &&
            config1?.config1?.app_id !== "6"
              ? ""
              : (data?.open ||
                  (aiInsightsLoader?.value &&
                    section_index === aiInsightsLoader?.s_i &&
                    widget_index === aiInsightsLoader?.w_i)) && (
                  <>
                    {aiInsightsLoader?.value &&
                    section_index === aiInsightsLoader?.s_i &&
                    widget_index === aiInsightsLoader?.w_i ? (
                      <div className="p-2 bg__gray">
                        {" "}
                        <Skeleton
                          active
                          style={{ borderBottom: "0.1rem solid silver" }}
                          variant="text"
                          width="100%"
                          height="6vh"
                        />
                      </div>
                    ) : data?.open &&
                      Array.isArray(data?.insights) &&
                      ((data?.insights?.[0]?.ai_generated_insights?.[
                        "top_key_insights"
                      ] &&
                        data?.insights?.[0]?.ai_generated_insights?.[
                          "top_key_insights"
                        ]?.[0] !== "") ||
                        data?.insights?.[0]?.ai_generated_insights?.[0]) ? (
                      <div className="p-15 bg__gray">
                        <div
                          className={`font-weight500 font-size14 text_heading mb-1 ${
                            config1?.config1?.app_id === "6"
                              ? "d-none"
                              : "d-flex"
                          }`}
                        >
                          AI Insights based on following prompt
                        </div>
                        <div
                          className={` ${
                            config1?.config1?.app_id === "6"
                              ? "d-none"
                              : "d-flex"
                          }`}
                        >
                          <div
                            className={`mr-15 w-100 floating-label-group mt-1`}
                          >
                            <Input
                              className="border-radius-4 border-color  mb-3"
                              placeholder="Enter your prompt here"
                              style={{ height: "3.5rem" }}
                              value={
                                promptText === ""
                                  ? ""
                                  : promptText
                                  ? promptText
                                  : data?.insights?.[0]?.prompt
                              }
                              allowClear={true}
                              onChange={(e) => handlePrompt(e)}
                              onPressEnter={() => handleEnter()}
                            />
                            <label
                              className="portlet-label floating-label ai_label font-size12"
                              style={{
                                zIndex: 1000,
                                top: "-0.8rem",
                              }}
                            >
                              Prompt
                            </label>
                          </div>
                          <Button
                            type="primary"
                            className={`ant-btn-primary_blue mt-1 ${
                              aiInsightsLoader?.value ? "disable" : ""
                            }`}
                            onClick={() => handleEnter()}
                            //disabled={aiInsightsLoader?.value && "state-disabled"}
                          >
                            Refresh
                          </Button>
                        </div>
                        {data?.insights?.[0]?.ai_generated_insights &&
                          data?.insights?.[0]?.ai_generated_insights !== "" && (
                            <>
                              <div className="font-weight500 font-size14 text_heading mb-3">
                                {config1?.config1?.app_id === "6" ||
                                  (config1?.config1?.app_id === "4" &&
                                    "AI Generated Insights")}
                                {(!data?.insights?.[0]?.prompt ||
                                  config1?.config1?.app_id === "6" ||
                                  config1?.config1?.app_id === "4") && (
                                  <span
                                    className={`ml-2 text-lightblue ${
                                      aiInsightsLoader?.value && "disable"
                                    }`}
                                    onClick={() => callInsights()}
                                  >
                                    <img
                                      src={Refreshblue}
                                      alt="refresh"
                                      className="mr-1 pb-1"
                                    />
                                    Refresh{" "}
                                  </span>
                                )}
                              </div>
                              {!data?.prompt_text &&
                              data?.insights?.[0]?.ai_generated_insights?.[
                                "top_key_insights"
                              ] ? (
                                <div
                                  style={{ marginTop: "-1rem" }}
                                  className="mb-1 d-flex flex-column"
                                >
                                  <span className="font-weight500 font-size13 text_heading mb-1">
                                    Top Key Insights
                                  </span>
                                  {Array.isArray(
                                    data?.insights?.[0]
                                      ?.ai_generated_insights?.[
                                      "top_key_insights"
                                    ]
                                  ) &&
                                    data?.insights?.[0]?.ai_generated_insights?.[
                                      "top_key_insights"
                                    ]?.map((el, i) => {
                                      return (
                                        <span className="text_regular-gray font-size14 pb-2 d-inline-flex">
                                          {config1?.config1?.app_id === "6" ? (
                                            ""
                                          ) : (
                                            <span className="mr-1 green-text">
                                              {i + 1}.
                                            </span>
                                          )}
                                          {el}
                                        </span>
                                      );
                                    })}
                                </div>
                              ) : !data?.prompt_text &&
                                data?.insights?.[0]?.ai_generated_insights &&
                                Array.isArray(
                                  data?.insights?.[0]?.ai_generated_insights
                                ) ? (
                                <div
                                  style={{ marginTop: "-1rem" }}
                                  className="mb-1 d-flex flex-column"
                                >
                                  <span className="font-weight500 font-size13 text_heading mb-1">
                                    Top Key Insights
                                  </span>
                                  {data?.insights[0]?.ai_generated_insights?.map(
                                    (el, i) => {
                                      return (
                                        <span className="text_regular-gray font-size14 pb-2 d-inline-flex">
                                          {config1?.config1?.app_id === "6" ? (
                                            ""
                                          ) : (
                                            <span className="mr-1 green-text">
                                              {i + 1}.
                                            </span>
                                          )}
                                          {el}
                                        </span>
                                      );
                                    }
                                  )}
                                </div>
                              ) : (
                                ""
                              )}

                              {!data?.prompt_text &&
                              data?.insights?.[0]?.ai_generated_insights?.[
                                "suggested_recommendations"
                              ] &&
                              Array.isArray(
                                data?.insights?.[0]?.ai_generated_insights?.[
                                  "suggested_recommendations"
                                ]
                              ) ? (
                                <div
                                  style={{ marginTop: "1rem" }}
                                  className="mb-0 d-flex flex-column"
                                >
                                  <span className="font-weight500 font-size13 text_heading mb-1">
                                    Suggested Recommendations
                                  </span>
                                  {data?.insights?.[0]?.ai_generated_insights?.[
                                    "suggested_recommendations"
                                  ]?.map((el, i) => {
                                    return (
                                      <span className="text_regular-gray font-size14 pb-2 d-inline-flex">
                                        {config1?.config1?.app_id === "6" ? (
                                          ""
                                        ) : (
                                          <span className="mr-1 green-text">
                                            {i + 1}.
                                          </span>
                                        )}
                                        {el}
                                      </span>
                                    );
                                  })}
                                </div>
                              ) : (
                                ""
                              )}
                              {data?.prompt_text &&
                                Array.isArray(
                                  data?.insights?.[0]?.ai_generated_insights
                                ) &&
                                data?.insights?.[0]
                                  ?.ai_generated_insights?.[0] && (
                                  <NewlineText
                                    text={
                                      data?.insights?.[0]
                                        ?.ai_generated_insights?.[0]
                                    }
                                  />
                                )}
                            </>
                          )}
                      </div>
                    ) : (
                      <>
                        <div className="p-15 bg__gray">
                          <div className="font-weight500 font-size14 text_heading mb-1">
                            AI Generated Insights{" "}
                            <span
                              className={`ml-2 text-lightblue ${
                                aiInsightsLoader?.value && "state-disabled"
                              }`}
                              onClick={() => callInsights()}
                            >
                              <img
                                src={Refreshblue}
                                alt="refresh"
                                className="mr-1 pb-1"
                              />
                              Retry{" "}
                            </span>
                          </div>

                          <i className="fas fa-exclamation-triangle error mr-1 "></i>

                          <span className="error font-size14">
                            {data?.insights}
                          </span>
                        </div>
                      </>
                    )}
                  </>
                )}

            {data?.x_axis || data?.y_series || data?.chart ? (
              <>
                <div
                  id={data?.widget_id}
                  className={`Dashboard__Widget--body ${
                    dashboard || footerValue?.template
                      ? "d-flex align-items-center w-100"
                      : " "
                  } ${
                    data?.chart?.chart_type === "post-card" ||
                    data?.chart?.chart_type === "survey-card" ||
                    data?.chart?.chart_type === "prolific-user" ||
                    data?.chart?.chart_type === "review-card" ||
                    data?.chart?.chart_type === "author-card"
                      ? "bg__gray"
                      : "bg__white"
                  }`}
                >
                  <WidgetMakerChart
                    metaWidgetConfig={data}
                    widget_index={widget_index}
                    section_index={section_index}
                    metaWidgetGraphData={
                      graphData?.data[
                        data?.chart?.chart_type === "horizontal-bar"
                          ? "bar"
                          : data?.chart?.chart_type
                      ]
                    }
                    dashboard={true}
                    metaWidgetKpiData={graphData?.data}
                    id={
                      section_index > 0
                        ? data?.widget_id + section_index + widget_index
                        : data?.widget_id + 0 + widget_index
                    }
                    span_data={span_data}
                    template_widget={template_widget}
                  />
                </div>
              </>
            ) : (
              <>
                {graphData?.graph_type === "aggregate" && (
                  <div
                    className="Dashboard__Widget--body portlet__body p-15"
                    id={
                      graphData?.widget_id
                        ? graphData?.widget_id
                        : data?.widget_id
                    }
                  >
                    <ErrorBoundary chart={true}>
                      <AggregateChart
                        id={
                          graphData?.widget_id
                            ? graphData?.widget_id
                            : data?.widget_id
                        }
                        data={graphData?.data}
                        datatype={graphData?.datatype}
                        description={graphData?.description}
                        graph_type={graphData?.graph_type}
                        type={graphData?.type}
                        allData={graphData}
                        createTemplate={true}
                        widget_index={widget_index}
                        section_index={section_index}
                        filters={data?.filters}
                      />
                    </ErrorBoundary>
                  </div>
                )}
                {graphData?.graph_type === "bar" && graphData?.stacked && (
                  <div
                    className="Dashboard__Widget--body portlet__body p-15"
                    id={
                      graphData?.widget_id
                        ? graphData?.widget_id
                        : data?.widget_id
                    }
                  >
                    <ErrorBoundary>
                      <HighCharts
                        single={
                          graphData?.percentData
                            ? graphData?.percentData
                            : graphData?.data
                        }
                        style={chart__styles}
                        xaxis={graphData?.x_label}
                        yaxis={graphData?.y_label}
                        stacked={true}
                        span_data={data?.span}
                        dashboard={true}
                        // id={
                        //   graphData?.widget_id
                        //     ? graphData?.widget_id
                        //     : data?.widget_id
                        // }
                        id={
                          section_index > 0
                            ? (graphData?.widget_id
                                ? graphData?.widget_id
                                : data?.widget_id) +
                              section_index +
                              widget_index
                            : (graphData?.widget_id
                                ? graphData?.widget_id
                                : data?.widget_id) +
                              0 +
                              widget_index
                        }
                        percent={graphData?.percent}
                        type="bar"
                        widget_index={widget_index}
                        section_index={section_index}
                        log={graphData?.log}
                        template_widget={template_widget}
                      />
                    </ErrorBoundary>

                    {/* <WidgetDescription description={graphData?.description} /> */}
                  </div>
                )}
                {graphData?.graph_type === "bar" && !graphData?.stacked && (
                  <div
                    className="Dashboard__Widget--body portlet__body p-15"
                    id={
                      graphData?.widget_id
                        ? graphData?.widget_id
                        : data?.widget_id
                    }
                  >
                    <ErrorBoundary>
                      <HighCharts
                        single={graphData?.data}
                        style={chart__styles}
                        xaxis={graphData?.x_label}
                        yaxis={graphData?.y_label}
                        stacked={graphData?.stacked}
                        span_data={data?.span}
                        dashboard={true}
                        type="bar"
                        id={
                          section_index > 0
                            ? (graphData?.widget_id
                                ? graphData?.widget_id
                                : data?.widget_id) +
                              section_index +
                              widget_index
                            : (graphData?.widget_id
                                ? graphData?.widget_id
                                : data?.widget_id) +
                              0 +
                              widget_index
                        }
                        widget_index={widget_index}
                        section_index={section_index}
                        log={graphData?.log}
                        template_widget={template_widget}
                      />
                    </ErrorBoundary>
                    {/* <WidgetDescription description={graphData?.description} /> */}
                  </div>
                )}
                {graphData?.graph_type === "pie" && (
                  <div
                    className="Dashboard__Widget--body portlet__body p-15"
                    id={
                      graphData?.widget_id
                        ? graphData?.widget_id
                        : data?.widget_id
                    }
                  >
                    <ErrorBoundary>
                      <HighCharts
                        single={graphData?.data}
                        style={chart__styles}
                        xaxis={graphData?.x_label}
                        yaxis={graphData?.y_label}
                        span_data={data?.span}
                        dashboard={true}
                        type="pie"
                        id={
                          section_index > 0
                            ? (graphData?.widget_id
                                ? graphData?.widget_id
                                : data?.widget_id) +
                              section_index +
                              widget_index
                            : (graphData?.widget_id
                                ? graphData?.widget_id
                                : data?.widget_id) +
                              0 +
                              widget_index
                        }
                        widget_index={widget_index}
                        section_index={section_index}
                        template_widget={template_widget}
                      />
                    </ErrorBoundary>
                    {/* <WidgetDescription description={graphData?.description} /> */}
                  </div>
                )}
                {graphData?.graph_type === "wordcloud" && (
                  <div
                    className="Dashboard__Widget--body portlet__body p-15"
                    id={
                      graphData?.widget_id
                        ? graphData?.widget_id
                        : data?.widget_id
                    }
                  >
                    <ErrorBoundary>
                      <HighCharts
                        single={graphData?.data}
                        id={
                          section_index > 0
                            ? (graphData?.widget_id
                                ? graphData?.widget_id
                                : data?.widget_id) +
                              section_index +
                              widget_index
                            : (graphData?.widget_id
                                ? graphData?.widget_id
                                : data?.widget_id) +
                              0 +
                              widget_index
                        }
                        style={chart__styles}
                        xaxis={graphData?.x_label}
                        yaxis={graphData?.y_label}
                        widget_index={widget_index}
                        section_index={section_index}
                        type={graphData?.graph_type}
                        dashboard={true}
                        template_widget={template_widget}
                      />
                    </ErrorBoundary>
                    {/* <WidgetDescription description={graphData?.description} /> */}
                  </div>
                )}
                {graphData?.graph_type === "area" && (
                  <div
                    className="Dashboard__Widget--body portlet__body p-15"
                    id={
                      graphData?.widget_id
                        ? graphData?.widget_id
                        : data?.widget_id
                    }
                  >
                    <ErrorBoundary>
                      <HighCharts
                        single={graphData?.data}
                        style={chart__styles}
                        log={graphData.log}
                        xaxis={graphData.x_label}
                        yaxis={graphData.y_label}
                        span_data={data?.span}
                        dashboard={true}
                        primary={
                          graphData?.primary
                            ? graphData?.primary
                            : data?.primary
                        }
                        type="area"
                        id={
                          section_index > 0
                            ? (graphData?.widget_id
                                ? graphData?.widget_id
                                : data?.widget_id) +
                              section_index +
                              widget_index
                            : (graphData?.widget_id
                                ? graphData?.widget_id
                                : data?.widget_id) +
                              0 +
                              widget_index
                        }
                        widget_index={widget_index}
                        section_index={section_index}
                        template_widget={template_widget}
                      />
                    </ErrorBoundary>
                    {/* <WidgetDescription description={graphData?.description} /> */}
                  </div>
                )}

                {graphData?.graph_type === "bubble" && (
                  <div
                    ref={refChartOut}
                    className="Dashboard__Widget--body portlet__body p-15"
                    id={
                      graphData?.widget_id
                        ? graphData?.widget_id
                        : data?.widget_id
                    }
                  >
                    <BubbleChart
                      let
                      uniqueId={uuid()}
                      single={graphData?.data}
                      style={chart__styles}
                      refChartOut={refChartOut.clientWidth}
                      WidgetEdit="edit"
                      widget_index={widget_index}
                      section_index={section_index}
                    />
                    {/* <WidgetDescription description={graphData?.description} /> */}
                  </div>
                )}
                {graphData?.graph_type === "sunburst" && (
                  <div
                    className="Dashboard__Widget--body portlet__body p-15"
                    id={
                      graphData?.widget_id
                        ? graphData?.widget_id
                        : data?.widget_id
                    }
                  >
                    <ErrorBoundary>
                      <HighCharts
                        single={graphData?.data}
                        style={chart__styles}
                        key={graphData?.x_label}
                        yaxis={graphData?.y_label}
                        type="sunburst"
                        span_data={data?.span}
                        dashboard={true}
                        id={
                          section_index > 0
                            ? (graphData?.widget_id
                                ? graphData?.widget_id
                                : data?.widget_id) +
                              section_index +
                              widget_index
                            : (graphData?.widget_id
                                ? graphData?.widget_id
                                : data?.widget_id) +
                              0 +
                              widget_index
                        }
                        widget_index={widget_index}
                        section_index={section_index}
                        template_widget={template_widget}
                      />
                    </ErrorBoundary>
                    {/* <WidgetDescription description={graphData?.description} /> */}
                  </div>
                )}

                {graphData?.graph_type === "map_pie" && (
                  <div
                    className="Dashboard__Widget--body portlet__body p-15"
                    id={
                      graphData?.widget_id
                        ? graphData?.widget_id
                        : data?.widget_id
                    }
                  >
                    <ErrorBoundary>
                      <MapGraph single={graphData?.data} />
                    </ErrorBoundary>
                    {/* <WidgetDescription description={graphData?.description} /> */}
                  </div>
                )}

                {graphData?.graph_type === "heatmap" && (
                  <div
                    className="Dashboard__Widget--body portlet__body p-15"
                    id={
                      graphData?.widget_id
                        ? graphData?.widget_id
                        : data?.widget_id
                    }
                  >
                    <ErrorBoundary>
                      <HighCharts
                        dashboard={true}
                        single={graphData?.data}
                        style={chart__styles}
                        xaxis={graphData?.x_label}
                        yaxis={graphData?.y_label}
                        desc={graphData?.description}
                        type="heat"
                        id={
                          section_index > 0
                            ? (graphData?.widget_id
                                ? graphData?.widget_id
                                : data?.widget_id) +
                              section_index +
                              widget_index
                            : (graphData?.widget_id
                                ? graphData?.widget_id
                                : data?.widget_id) +
                              0 +
                              widget_index
                        }
                        widget_index={widget_index}
                        section_index={section_index}
                        template_widget={template_widget}
                      />
                    </ErrorBoundary>
                    {/* <WidgetDescription description={graphData?.description} /> */}
                  </div>
                )}
                {graphData?.graph_type === "table" && (
                  <div
                    className="Dashboard__Widget--body mt-15 pl-15 pr-15"
                    style={chart__styles}
                  >
                    <ErrorBoundary>
                      <div style={{ minHeight: "40rem", overflow: "auto" }}>
                        <TableCharts single={graphData?.data} />
                      </div>
                    </ErrorBoundary>
                    {/* <WidgetDescription description={graphData?.description} /> */}
                  </div>
                )}
                {graphData?.graph_type === "line" &&
                  !(graphData?.widget_id?.slice(0, 11) === "tickets_orm") && (
                    <div className="Dashboard__Widget--body portlet__body p-15">
                      <ErrorBoundary>
                        <HighCharts
                          single={graphData?.data}
                          style={chart__styles}
                          xaxis={graphData?.x_label}
                          yaxis={graphData?.y_label}
                          primary={
                            graphData?.primary
                              ? graphData?.primary
                              : data?.primary
                          }
                          type="line"
                          id={
                            section_index > 0
                              ? (graphData?.widget_id
                                  ? graphData?.widget_id
                                  : data?.widget_id) +
                                section_index +
                                widget_index
                              : (graphData?.widget_id
                                  ? graphData?.widget_id
                                  : data?.widget_id) +
                                0 +
                                widget_index
                          }
                          dashboard={true}
                          widget_index={widget_index}
                          section_index={section_index}
                          log={graphData?.log}
                          template_widget={template_widget}
                        />
                      </ErrorBoundary>
                      {/* <WidgetDescription description={graphData?.description} /> */}
                    </div>
                  )}

                {graphData?.widget_id?.slice(0, 11) === "tickets_orm" && (
                  <div className="Dashboard__Widget--body portlet__body p-15">
                    <ErrorBoundary>
                      <div>
                        <OrmGraphs single={graphData} style={chart__styles} />
                      </div>
                    </ErrorBoundary>
                  </div>
                )}

                {graphData?.widget_id?.slice(0, 14) === "tickets_simple" && (
                  <div className="Dashboard__Widget--body portlet__body p-15">
                    <ErrorBoundary>
                      <div>
                        <TicketTat
                          dashboard={true}
                          widgetsData={graphData}
                          style={chart__styles}
                        />
                      </div>
                    </ErrorBoundary>
                  </div>
                )}
              </>
            )}
          </>
        ) : (
          (typeof graphData === "string" ||
            typeof graphData?.data === "string") && (
            <>
              <div
                ref={ref}
                id={data?.widget_id + "#" + section_id + "#" + widget_index}
                className="Dashboard__Widget--header"
              >
                <WidgetHeader
                  id={propsId}
                  widget_name={
                    data?.widget_name
                      ? data?.widget_name
                      : graphData?.widget_name
                      ? graphData?.widget_name
                      : template_widget
                      ? Section?.[section_index]?.data[widget_index]
                          ?.widget_name
                      : sections
                      ? sections?.[section_index]?.widgets[widget_index]
                          ?.widget_name
                      : section &&
                        section[0]?.widgets[widget_index]?.widget_name
                  }
                  widget_description={
                    data?.widget_description
                      ? data?.widget_description
                      : graphData?.widget_description
                      ? graphData?.widget_description
                      : template_widget
                      ? Section?.[section_index]?.data[widget_index]
                          ?.widget_description
                      : sections
                      ? sections?.[section_index]?.widgets[widget_index]
                          ?.widget_description
                      : section &&
                        section[0]?.widgets[widget_index]?.widget_description
                  }
                  section_id={section_id}
                  widget_id={data?.widget_id ? data?.widget_id : data?.id}
                  widget_index={widget_index}
                  section_index={section_index}
                  graph_type={graphData?.graph_type}
                  widgets={graphData}
                  template_widget={template_widget}
                  dashboard={dashboard}
                  sections={sections}
                  chart_type={data?.graph_type}
                  widgetData={data}
                  pane_section={panes?.[index]?.section}
                  selectedDeepdiveWidget={
                    shareTemplateData
                      ? share_selected_deepdive_widget
                      : panes?.[index]?.selected_deepdive_widget
                  }
                  templateAccessType={panes?.[index]?.access_type}
                />
              </div>
              <div className="Dashboard__Widget--body portlet__body p-15">
                <ErrorBoundary>
                  {graphData === "Something went wrong" ? (
                    <>
                      <SomethingWrong
                        widgetData={data}
                        section_index={section_index}
                        widget_index={widget_index}
                      />
                    </>
                  ) : reason && plateformId ? (
                    <div className={`d-flex align-items-center full_nodata`}>
                      <div
                        className={`w-100 text-center ${
                          reason && plateformId
                            ? "d-flex align-items-center flex-direction-column"
                            : ""
                        }`}
                      >
                        <div className="Nodata_img mb-15">
                          <img
                            src={SocialMedialogoDeprecated?.[plateformId]}
                            alt="Twitter Depricated Widget Image"
                          />
                        </div>

                        <span
                          className="depricated_widget_alert_text"
                          style={{
                            width: reason && plateformId ? "70%" : "auto",
                          }}
                        >
                          <WarningOutlined className="mr-2" />
                          <span> {reason}</span>
                        </span>
                      </div>
                    </div>
                  ) : (
                    <ErrorBoundary>
                      <NoGraphData
                        errorCode={
                          graphData?.data
                            ? graphData?.data
                            : graphData
                            ? graphData
                            : errorCode
                        }
                      />
                    </ErrorBoundary>
                  )}
                </ErrorBoundary>
              </div>
            </>
          )
        )}
      </>
    );
};

export default React.memo(WidgetGraph, isEqual);
